import { getCollapseStateValues } from 'app/selectors';
import { setCollapseState } from 'features/memoizedValues/collapseStateSlice';

import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useSaveCollapseState = () => {
    const dispatch = useDispatch();

    const memoizedValues = useSelector(getCollapseStateValues);

    const handleSaveTreeState = useCallback(
        ({ key, newState }: { key: string; newState: boolean }) => {
            dispatch(
                setCollapseState({
                    key,
                    value: newState,
                }),
            );
        },
        [dispatch],
    );

    const handleCheckIsOpen = useCallback((key: string) => !!memoizedValues[key], [memoizedValues]);

    return useMemo(
        () => ({
            handleSaveTreeState,
            handleCheckIsOpen,
        }),
        [handleCheckIsOpen, handleSaveTreeState],
    );
};
